import { render, staticRenderFns } from "./SelectedTemplateDashboard.vue?vue&type=template&id=3a53b398&scoped=true"
import script from "./SelectedTemplateDashboard.vue?vue&type=script&lang=js"
export * from "./SelectedTemplateDashboard.vue?vue&type=script&lang=js"
import style1 from "./SelectedTemplateDashboard.vue?vue&type=style&index=1&id=3a53b398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53b398",
  null
  
)

export default component.exports